import { t } from 'i18next';

export enum OperationAlgorithm {
  AES = 'AES',
  AESWRAP = 'AESWRAP',
  BKS = 'BKS',
  BLOWFISH = 'BLOWFISH',
  CAMELLIA = 'CAMELLIA',
  CAST5 = 'CAST5',
  DES = 'DES',
  DES_EDE_2KEY = 'DES_EDE_2KEY',
  DES_EDE_3KEY = 'DES_EDE_3KEY',
  DH = 'DH',
  DSA = 'DSA',
  ECDH = 'ECDH',
  ECDSA = 'ECDSA',
  ECIES = 'ECIES',
  ECMQV = 'ECMQV',
  EVP_BYTESTOKEY = 'EVP_BYTESTOKEY',
  IDEA = 'IDEA',
  JCEKS = 'JCEKS',
  JKS = 'JKS',
  KECCAK224 = 'KECCAK224',
  KECCAK256 = 'KECCAK256',
  KECCAK288 = 'KECCAK288',
  KECCAK384 = 'KECCAK384',
  KECCAK512 = 'KECCAK512',
  MD2 = 'MD2',
  MD5 = 'MD5',
  PBKDF1 = 'PBKDF1',
  PBKDF2 = 'PBKDF2',
  PKCS12_PBE = 'PKCS12_PBE',
  RC2 = 'RC2',
  RC4 = 'RC4',
  RC5 = 'RC5',
  RSA = 'RSA',
  SEED = 'SEED',
  SHA1 = 'SHA1',
  SHA224 = 'SHA224',
  SHA256 = 'SHA256',
  SHA384 = 'SHA384',
  SHA3_224 = 'SHA3_224',
  SHA3_256 = 'SHA3_256',
  SHA3_384 = 'SHA3_384',
  SHA3_512 = 'SHA3_512',
  SHA512 = 'SHA512',
  SHA512_224 = 'SHA512_224',
  SHA512_256 = 'SHA512_256',
  SUN_JCE_CUSTOM_MD5_TRIPLE_DES = 'SUN_JCE_CUSTOM_MD5_TRIPLE_DES',
}

export const getOperationAlgorithmLabel = (algorithm: OperationAlgorithm): string => {
  return t(`operationProperties.algorithms.${algorithm}`);
};
